export const LOADING = "LOADING" // in caricamento
export const LOADING_BLOCKING = "LOADING_BLOCKING" // in caricamento bloccante
export const SUCCEDED = "SUCCESS"// ha avuto successo
export const ERROR = "ERROR"// ha generato errore
export const IDLE = "IDLE"// non è stata invocata